export const DEFAULT_TILE_HEIGHT = 72;

// Mirrors the toolkit TileGrid defaults, which it does not export.
export const DEFAULT_TILE_WIDTH = 230;
export const DEFAULT_TILE_GAP = 20;

/** Width TileGrid occupies at `columnCount` columns; the last column carries no trailing gap. */
export function getTileGridWidth(columnCount: number): number {
  return columnCount * DEFAULT_TILE_WIDTH + (columnCount - 1) * DEFAULT_TILE_GAP;
}
